module.exports = __webpack_public_path__ + "static/media/store-harmons.061972ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/stores/store-harmons.jpg
// module id = 229
// module chunks = 0